import styled, { css } from 'styled-components'
import Icon from 'components/priority/Icon/Icon'

export const DropIcon = styled(Icon)<{ up: number }>(
  ({ up }) => css`
    transform: rotate(${up ? '-180deg' : '0deg'});
    transition: 0.25s;
  `,
)
